import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { Editing } from "devextreme-react/scheduler";
import { ButtonItem } from "devextreme-react/tree-list";
import UserInfo from "../../UserInfo";
import { inserirOuAtualizar, criarFatorCorretivoDs } from "../../DataSources";
import uiInfo from "../../ui-info";
import {
  Column,
  DataGrid,
  Paging,
  Pager,
  HeaderFilter,
  FilterRow,
} from "devextreme-react/data-grid";
import PaginaToolbar from "../../components/PaginaToolbar";
import ShowError from "../../AppServices";

const template = {
  id: undefined,
  prefeituraId: undefined,
  tipo: "",
  variavel: "",
  descricao: "",
  opcoes: [],
};

export default class FatoresCorretivosForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    template.prefeituraId = UserInfo.getPrefeitura();
    this.fatoresCorretivosDs = criarFatorCorretivoDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.fatoresCorretivosDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (!data) {
            notify("Fator corretivo não encontrado.", "error");
            this.props.history.push("/fatorescorretivos");
          }
          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }

    if (this.props.match.params.id === undefined) {
      this.setState({ ...template });
    }
  }

  render() {
    const tipoFator = [
      { id: "T", descricao: "Terreno" },
      { id: "E", descricao: "Edifício" },
    ];

    const escolherTipoFator = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: tipoFator,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <Form formData={this.state} colCount={2}>
          <GroupItem caption="FATORES CORRETIVOS" colSpan={2} colCount={3}>
            <SimpleItem
              dataField={"tipo"}
              editorType={"dxLookup"}
              editorOptions={escolherTipoFator}
              colSpan={1}
            >
              <Label text="Tipo" />
            </SimpleItem>
            <SimpleItem dataField={"variavel"} colSpan={2}>
              <Label text="Variável" />
            </SimpleItem>
          </GroupItem>
          <GroupItem colCount={3} colSpan={2}>
            <SimpleItem dataField={"descricao"} editorType={"dxTextBox"}>
              <Label text="Descrição" />
            </SimpleItem>
            <SimpleItem dataField={"codigoCtm"} editorType={"dxTextBox"}>
              <Label text="Código no CTM" />
            </SimpleItem>
            <SimpleItem dataField={"codigoRefProducao"} editorType={"dxTextBox"}>
              <Label text="Código Ref. da Producao" />
            </SimpleItem>
          </GroupItem>
        </Form>

        <PaginaToolbar titulo="Opções">
          <DataGrid
            dataSource={this.state.opcoes}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            wordWrapEnabled={true}
            onInitNewRow={this.initNewRow}
          >
            <HeaderFilter visible={true} />
            <FilterRow visible={true} />
            <Editing
              mode={"row"}
              allowAdding={false}
              allowUpdating={true}
              allowDeleting={true}
            />
            <Column
              dataField={"id"}
              caption={"#"}
              width={"150"}
              allowEditing={false}
            />
            <Column
              dataField={"fatorId"}
              caption={"Id do Fator"}
              visible={false}
            />
            <Column
              dataField={"prefeituraId"}
              caption={"Prefeitura"}
              visible={false}
            />
            <Column dataField={"descricao"} caption={"Descrição"} />
            <Column dataField={"comando"} caption={"Comando"} />
            <Column dataField={"codigoCtm"} caption={"Código CTM"} />
            <Column dataField={"codigoRefProducao"} caption={"Código Ref. Produção"} />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
        <br></br>
        <Form>
          <GroupItem colCount={6}>
            <ButtonItem
              horizontalAlignment={"left"}
              buttonOptions={{
                type: "success",
                text: "Salvar",
                onClick: this.ok,
              }}
            />
            <ButtonItem
              horizontalAlignment={"left"}
              buttonOptions={{
                type: "warn",
                text: "Cancelar",
                onClick: this.cancel,
              }}
            />
          </GroupItem>
        </Form>
      </div>
    );
  }

  initNewRow(e) {
    e.data.prefeituraId = UserInfo.getPrefeitura();
  }

  ok() {
    const entidade = this.state;
    inserirOuAtualizar(this.fatoresCorretivosDs, entidade)
      .then(
        function () {
          notify("Fator Corretivo cadastrado com sucesso.", "success");
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
